import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createEntryUsersAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        entry_id: requiredUuid(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
        client_created_at: requiredNumber(),
        client_updated_at: requiredNumber(),
        archived_at: requiredNumber(),
    });

export const createEntryUsersUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createEntryUsersAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.entry_users,
    );

export const createEntryUsersDeleteSchema = () => createDeleteSchema();

export const createEntryUsersSchemas = () => ({
    add: createEntryUsersAddSchema(),
    update: createEntryUsersUpdateSchema(),
    delete: createEntryUsersDeleteSchema(),
});
